export async function fetchStaff() {
  const res = await fetch('/api/staff');
  if (!res.ok) {
    throw new Error(`Staff directory request failed (${res.status})`);
  }
  return res.json();
}

// Re-exported for backward compatibility — the real definition now lives in
// driveImage.js since Gallery needs it too.
export { resolveImageUrl } from './driveImage';

export function slugify(name) {
  return (name || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
